import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xMThxcjQ3MCB7CiAgc2Nyb2xsLW1hcmdpbi10b3A6IGNhbGModmFyKC0tXzFrbWxtZzUxNzMpICsgMjVweCk7Cn0';
export var idHashOffset = '_118qr470';